import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Clearfix } from "react-bootstrap";
import { applicatSignUp } from "../../redux/middleware/user";

import {
  Container,
  ApplicationIcon,
  ProfileIcon,
  SearchIcon,
  RightPane,
  LeftPane,
  Process,
  GreyBlock,
  styles,
} from "./Styles/UserRegistation.styles";
import RegisterForn from "./Components/RegisterForm";


class UserRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fname: "",
      lname: "",
      email: "",
      password: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const { notify, pending } = this.props;
    if (pending && !nextProps.pending) {
      console.log(nextProps)
      if (
        nextProps.error &&
        nextProps.error.response &&
        nextProps.error.response.status !== 422
      )
        notify(
          "error",
          nextProps.error.response.data.message ||
            nextProps.error.response?.statusText
        );
      else if (nextProps.user && nextProps.message && nextProps.authToken) {
        notify("success", nextProps.message);
        localStorage.setItem(
          "qcUserToken",
          JSON.stringify(nextProps.authToken)
        );
        localStorage.setItem("qcUser", JSON.stringify(nextProps.user));
        const profileId = nextProps.profile.id;
        window.location.href = `/dashboard/profiles/${profileId}/edit`;
      }
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleError = (type, message) => this.props.notify(type, message);

  handleSubmit = () => {
    const { fname, lname, email, password, passwordConfirmation } = this.state;
    const { applicatSignUp: applicatSignUpAction } = this.props;
    if (this.validate()) {
      const data = {
        fname,
        lname,
        email,
        password,
        password_confirmation: passwordConfirmation,
      };
      applicatSignUpAction(data);
    }
  };

  validate = () => {
    const { fname, lname, email, password, passwordConfirmation } = this.state;
    const errors = [];
    if (fname === undefined || fname === "") {
      errors.push({ field: "fname", message: "First name can't be blank" });
    }
    if (lname === undefined || lname === "") {
      errors.push({ field: "lname", message: "Last name can't be blank" });
    }
    if (email === undefined || email === "") {
      errors.push({ field: "email", message: "Email can't be blank" });
    }
    if (password === undefined || password === "") {
      errors.push({ field: "password", message: "Password can't be blank" });
    }
    if (passwordConfirmation === undefined || passwordConfirmation === "") {
      errors.push({
        field: "passwordConfirmation",
        message: "Password Confirmation can't be blank",
      });
    }
    errors
      .map((error) => error.message)
      .forEach((error) => this.handleError("error", error));
    return errors.length === 0;
  };

  render() {
    const { lname, fname, email } = this.state;
    return (
      <Container className="clearfix">
        <div style={styles.banner}>
          <div className="container">
            <Row>
              <LeftPane>
                <h1 style={styles.banner.h1}>
                  Register on QuirkyCoders and search thousands of programming
                  jobs
                </h1>
                <Process>
                  <ApplicationIcon />
                  <div className="process-text">
                    <h2>Register</h2>
                    <p>
                      Signing up is easy. QuirkyCoders is always free for coding
                      professionals.
                    </p>
                  </div>
                  <Clearfix />
                </Process>
                <Process>
                  <ProfileIcon />
                  <div className="process-text">
                    <h2>Create a profile and upload your resume</h2>
                    <p>
                      Showcase your skills and let employers and recruiters find
                      you.
                    </p>
                  </div>
                  <Clearfix />
                </Process>
                <Process>
                  <SearchIcon />
                  <div className="process-text">
                    <h2>Search and apply to thousands of tech jobs</h2>
                    <p>Apply with just the touch of a button!</p>
                  </div>
                  <Clearfix />
                </Process>
              </LeftPane>
              <RightPane>
                <div style={styles.banner.rightTab}>
                  <ul style={styles.banner.rightTab.ul}>
                    <li style={styles.banner.rightTab.li}>
                      <Link
                        to="/employers/post-job"
                        style={{ color: "#fff", textDecoration: "none" }}
                      >
                        Post a Job
                      </Link>
                    </li>
                    <li style={styles.banner.rightTab.li}>
                      <Link
                        to="/contact-us"
                        style={{ color: "#fff", textDecoration: "none" }}
                      >
                        Recruiting
                      </Link>
                    </li>
                    <li style={styles.banner.rightTab.liLast}>
                      <Link
                        to="/contact-us"
                        style={{ color: "#fff", textDecoration: "none" }}
                      >
                        Contact Sales
                      </Link>
                    </li>
                  </ul>
                </div>
                <div style={styles.banner.registerBlock} className="post">
                  <h1 style={styles.banner.registerBlock.h1}>
                    Register to Search Jobs
                  </h1>
                  <RegisterForn
                    styles={styles}
                    fname={fname}
                    lname={lname}
                    email={email}
                    handleSubmit={this.handleSubmit}
                    handleChange={this.handleChange}
                  />
                </div>
              </RightPane>
            </Row>
          </div>
        </div>
        <div style={styles.blueGreenBlock}>
          <div className="container">
            <div style={styles.hireBlock}>
              <h1 style={styles.hireBlock.h1} className="post">
                Looking to hire ?
              </h1>
              <p style={styles.hireBlock.p}>
                Browse our database to find highly skilled candidates.
              </p>
            </div>
            <div style={styles.buttonBlock}>
              <Link style={styles.buttonBlock.a} to="/employers/post-job">
                Post a Job
              </Link>
              <Link style={styles.buttonBlock.a} to="/login">
                Employer Login
              </Link>
              <Link style={styles.buttonBlock.a} to="/contact-us">
                Contact sales
              </Link>
            </div>
          </div>
        </div>
        <GreyBlock>
          <div className="container">
            <div className="box-left">
              <div className="application-icon" />
              <h3>Get Notified</h3>
              <p>
                Sign up for job alerts and get the newest job postings you want
                delivered right to your email.
              </p>
            </div>
            <div className="box">
              <div className="search-icon" />
              <h3>Get Found</h3>
              <p>
                Employers and recruiters use QuirkyCoders to find candidates
                like you. Make your resume searchable and allow recruiters to
                contact you. Your job search just got easier!
              </p>
            </div>
            <div className="box-right">
              <div className="hired-icon" />
              <h3>Get Hired</h3>
              <p>
                QuirkyCoders connects the best tech talent with jobs around the
                world. Whether you're a developer, engineer, or QA tester,
                QuirkyCoders has what you need to keep your career on track.
              </p>
            </div>
          </div>
        </GreyBlock>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.createUser.user?.user,
  pending: state.createUser.pending,
  error: state.createUser.error,
  message: state.createUser.message,
  authToken: state.createUser.authToken,
  profile: state.createUser.profile,
});

const mapDispatchToProps = (dispatch) => ({
  applicatSignUp: (data) => dispatch(applicatSignUp(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserRegistration);
